import React, { useState, useEffect } from 'react';
import StyledUSMap from './assets/StyledUSMap';
import { Helmet } from 'react-helmet';

const Page = () => {
  const [stateStatus, setStateStatus] = useState({});
  const [redVotes, setRedVotes] = useState(0);
  const [blueVotes, setBlueVotes] = useState(0);
  const [uncommittedVotes, setUncommittedVotes] = useState(0);
  const [electoralData, setElectoralData] = useState({ states: [] });

  useEffect(() => {
    fetch(`${process.env.PUBLIC_URL}/data/electoral.json`)
      .then(response => response.json())
      .then(data => {
        setElectoralData(data);
        setUncommittedVotes(data.states.reduce((sum, state) => sum + state.electoralVotes, 0));
      });
  }, []);

  useEffect(() => {
    let red = 0;
    let blue = 0;
    let uncommitted = 0;
    electoralData.states.forEach((state) => {
      const status = stateStatus[state.name];
      if (status === 'red') red += state.electoralVotes;
      else if (status === 'blue') blue += state.electoralVotes;
      else uncommitted += state.electoralVotes;
    });
    setRedVotes(red);
    setBlueVotes(blue);
    setUncommittedVotes(uncommitted);
  }, [stateStatus, electoralData]);

  const handleStateClick = (stateName) => {
    setStateStatus(prevStatus => {
      const currentStatus = prevStatus[stateName];
      let newStatus;
      if (currentStatus === 'red') newStatus = 'blue';
      else if (currentStatus === 'blue') newStatus = 'white';
      else newStatus = 'red';
      return { ...prevStatus, [stateName]: newStatus };
    });
  };

  const getStateColor = (stateName) => {
    switch (stateStatus[stateName]) {
      case 'red': return '#f43f5e';
      case 'blue': return '#0ea5e9';
      default: return '#f9f9f9';
    }
  };

  const totalVotes = redVotes + blueVotes + uncommittedVotes;

  return (
    <>
      <Helmet>
        <title>Electoral Game | Project V.O.T.E.</title>
      </Helmet>
      <div className="mx-auto max-w-7xl sm:px-4 md:px-6 lg:px-8 h-full">
        <div className="mx-auto max-w-7xl bg-white p-3 rounded-t-lg">
          <h1 className="mb-4 text-2xl font-bold">Electoral College Game</h1>

          {/* Bar Graph */}
          <div className="mb-4">
            <div className="flex justify-between mt-2 text-sm">
              <h2 className="text-rose-600">Red: {redVotes}</h2>
              <h3 className="text-gray-500">Open: {uncommittedVotes}</h3>
              <h2 className="text-sky-700">Blue: {blueVotes}</h2>
            </div>
            <div className="flex h-8 w-full rounded-full overflow-hidden">
              <div
                className="bg-rose-500"
                style={{ width: `${(redVotes / totalVotes) * 100}%` }}
                title={`Red: ${redVotes} votes`}
              ></div>
              <div
                className="bg-gray-300"
                style={{ width: `${(uncommittedVotes / totalVotes) * 100}%` }}
                title={`Uncommitted: ${uncommittedVotes} votes`}
              ></div>
              <div
                className="bg-sky-500"
                style={{ width: `${(blueVotes / totalVotes) * 100}%` }}
                title={`Blue: ${blueVotes} votes`}
              ></div>
            </div>

          </div>

          <StyledUSMap
            stateStatus={stateStatus}
            getStateColor={getStateColor}
            onClick={handleStateClick}
          />

          <div className="mt-4">
            <h3 className="font-bold">How to Play:</h3>
            <ul className="list-disc list-inside">
              <li>Click on a state to cycle through Red, Blue, and Unassigned (White) status.</li>
              <li>Each state shows its abbreviation and number of electoral votes.</li>
              <li>The bar at the top shows the distribution of electoral votes.</li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
}

export default Page;